"use client";

import { useLanguage } from "@/contexts/language-context";

interface TradeRecommendationProps {
  recommendation: {
    asset: string;
    deeplink: string;
    price?: string;
  };
}

export default function TradeRecommendation({ recommendation }: TradeRecommendationProps) {
  const { t } = useLanguage();
  const { asset, deeplink, price } = recommendation;

  const formattedPrice = (() => {
    if (!price) {
      return t("trade.priceUnavailable");
    }
    const numeric = Number(String(price).replace(/[^0-9.\-]/g, ""));
    if (Number.isFinite(numeric)) {
      return `USD ${numeric.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return price;
  })();

  return (
    <div
      className="flex w-full max-w-full flex-col gap-4 border border-gray-200 p-4 shadow-sm dark:border-gray-700 sm:p-5"
      style={{
        backgroundColor: '#f5f5f5',
        borderRadius: '15px'
      }}
    >
      {/* Asset Symbol/Ticker at top */}
      <div className="flex items-center gap-2">
        <span className="font-semibold text-gray-900 dark:text-gray-100 text-lg">
          {asset}
        </span>
      </div>

      {/* Inner container with price and trade button */}
      <div
        className="flex flex-col gap-4 bg-white p-4 dark:bg-gray-800 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:p-5"
        style={{ borderRadius: '15px' }}
      >
        {/* Current Price */}
        <h3 className="break-words text-base font-bold text-gray-900 dark:text-gray-100">
          {t("trade.currentPrice")}: {formattedPrice}
        </h3>

        {/* Trade Button */}
        <a
          href={deeplink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full cursor-pointer whitespace-nowrap bg-[#034854] px-6 py-2.5 text-center text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:bg-[#034854]/90 hover:shadow-md sm:w-auto"
          style={{ borderRadius: '25px' }}
        >
          {t("trade.tradeButton")}
        </a>
      </div>
    </div>
  );
}
